import { type FC } from 'react';
import { Flex } from '@repo/ui/Flex';
import s from './ImageCarousel.module.css';

type Image = {
  id?: string | null;
  name?: string | null;
  url?: string | null;
};

type ImageCarouselProps = {
  images: Image[];
};

export const ImageCarousel: FC<ImageCarouselProps> = ({ images }) => {
  return (
    <Flex className={s.flexCarousel}>
      {images &&
        images.length > 0 &&
        images.map(({ url, name }, index) => (
          <div key={url ?? index} className={s.imageWrapper}>
            <img alt={name ?? ''} src={url ?? ''} className={s.image} />
          </div>
        ))}
    </Flex>
  );
};
